var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCornerMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 75,
    viewBox: "0 0 234 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0886 0H233.321C220.859 4.89655 208.517 10.12 197.414 18.6572C185.468 27.8518 175.168 40.7262 164.916 53.544L164.828 53.6544C159.262 60.624 153.693 67.5986 148.244 74.7865H0.000274658V16.9545C6.73508 14.4518 13.5512 12.2208 20.5735 10.7436C29.3582 8.90596 38.427 8.26129 47.4976 7.61648C54.3885 7.12662 61.2806 6.63668 68.0501 5.62355C76.2418 4.40569 84.2266 2.42864 92.0886 0Z",
    fill: "#FF9F00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerMobile);
export default __webpack_public_path__ + "static/media/cornerMobile.0de503e650d90f1f798b6be755501097.svg";
export { ForwardRef as ReactComponent };